<template>
  <div class="shebei">
    <div class="time-line">
      <div
        class="item"
        v-for="(item, index) in times"
        :key="index"
        @click="changeItem(index)"
      >
        <div class="dot" :class="timesActiveIndex == index ? 'active' : ''">
          <div class="inner"></div>
        </div>
        <div class="label" :class="timesActiveIndex == index ? 'active' : ''">
          {{ item.value }}
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="main">
      <div class="step1" v-if="timesActiveIndex == 0">
        <div class="box" v-if="!showList">
          <img src="../../assets/images/begin.png" alt="" />
          <el-button type="primary" round @click="dialogVisible = true"
            >开始配置</el-button
          >
        </div>
        <div class="box box2" v-if="showList">
          <div class="operation-box">
            <div class="add" @click="addLi">+</div>
            <ul>
              <li
                v-for="(item, index) in equipmentRoomList"
                :key="index"
                @keyup.enter="addorEdit(index)"
              >
                <p v-if="equipmentRoomIndex !== index" :title="item.roomName">
                  {{ item.roomName }}
                </p>
                <!-- :value="item.roomName" -->
                <input
                  v-else
                  type="text"
                  ref="addDom"
                  maxlength="10"
                  :value="item.roomName"
                  @blur="dialogVisible = false"
                  @input="updateValue($event, index)"
                  @keyup="item.roomName = item.roomName.replace(/\s+/g, '')"
                />
                <div class="icon-box">
                  <i
                    v-if="!(equipmentRoomIndex === index)"
                    class="iconfont icon-bianji2"
                    @mousedown="editThis(index)"
                  ></i>
                  <i
                    v-if="!(equipmentRoomIndex === index)"
                    @mousedown="deleteEquipmentRoom(item.id)"
                    class="iconfont icon-close"
                  ></i>
                  <i
                    v-if="equipmentRoomIndex === index"
                    @mousedown="addorEdit(index)"
                    class="iconfont icon-huiche"
                  ></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="step2" v-if="timesActiveIndex == 0">
        <el-dialog
          title="创建配电室"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          width="30%"
        >
          <div class="operation-box">
            <div class="add" @click="addLi">+</div>
            <ul>
              <li
                v-for="(item, index) in equipmentRoomList"
                :key="index"
                @keyup.enter="addorEdit(index)"
              >
                <p v-if="equipmentRoomIndex !== index">{{ item.roomName }}</p>
                <input
                  v-else
                  type="text"
                  maxlength="15"
                  ref="addDom"
                  :value="item.roomName"
                  @blur="dialogVisible = false"
                  @input="updateValue($event, index)"
                  @keyup="item.roomName = item.roomName.replace(/\s+/g, '')"
                />
                <div class="icon-box">
                  <i
                    v-if="!(equipmentRoomIndex === index)"
                    class="iconfont icon-bianji2"
                    @mousedown="editThis(index)"
                  ></i>
                  <i
                    v-if="!(equipmentRoomIndex === index)"
                    @mousedown="deleteEquipmentRoom(item.id)"
                    class="iconfont icon-close"
                  ></i>
                  <i
                    v-if="equipmentRoomIndex === index"
                    @mousedown="addorEdit(index)"
                    class="iconfont icon-huiche"
                  ></i>
                </div>
              </li>
            </ul>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false"
              >确 定</el-button
            >
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
      </div>
      <div class="step3" v-if="timesActiveIndex == 1">
        <shebeiM></shebeiM>
      </div>
      <div class="step4" v-if="timesActiveIndex == 2">
        <yibiao></yibiao>
      </div>
      <div class="step5" v-if="timesActiveIndex == 3">
        <zhiliuping></zhiliuping>
      </div>
      <div class="step6" v-if="timesActiveIndex == 4">
        <zongbao></zongbao>
      </div>
      <div class="step7" v-if="timesActiveIndex == 5">
        <wenkong></wenkong>
      </div>
      <div class="step8" v-if="timesActiveIndex == 6">
        <huanjing></huanjing>
      </div>
      <div class="step9" v-if="timesActiveIndex == 7">
        <shipin></shipin>
      </div>
      <div class="step10" v-if="timesActiveIndex == 8">
        <jiegou></jiegou>
      </div>
    </div>
  </div>
</template>

<script>
import shebeiM from "../../components/shebei/shebeiM";
import yibiao from "../../components/shebei/yibiao";
import zhiliuping from "../../components/shebei/zhiliuping";
import zongbao from "../../components/shebei/zongbao";
import wenkong from "../../components/shebei/wenkong";
import huanjing from "../../components/shebei/huanjing";
import shipin from "../../components/shebei/shipin";
import jiegou from "../../components/shebei/jiegou";
import {
  Message
} from 'element-ui';
export default {
  components: {
    shebeiM,
    yibiao,
    zhiliuping,
    zongbao,
    wenkong,
    huanjing,
    shipin,
    jiegou,
  },
  data() {
    return {
      id: "",
      timesActiveIndex: 0,
      times: [
        {
          value: "创建配电室",
        },
        {
          value: "设备配置",
        },
        {
          value: "仪表配置",
        },
        {
          value: "创建直流屏",
        },
        {
          value: "创建综保",
        },
        {
          value: "创建温控",
        },
        {
          value: "创建环境设备",
        },
        {
          value: "视频设备",
        },
        {
          value: "生成结构",
        },
      ],
      dialogVisible: false,
      equipmentRoomList: [],
      equipmentRoomIndex: -1,
      showList: false,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .post(
          "bma-distribution-service/equipmentRoom/searchEquipmentRoomList",
          {
            projectId: this.id,
          }
        )
        .then((res) => {
          console.log("获取配电室", res);
          this.equipmentRoomList = res.data;
          if (res.data.length > 0) {
            this.showList = true;
          } else {
            this.showList = false;
          }
        });
    },
    addEquipmentRoom(name) {
      let filterName = name.replace(/\s*/g, "");
      if (!name) {
        this.getData();
        return false;
      }
      if (!filterName) {
        this.getData();
        return false;
      } else {
        this.$http
          .post("bma-distribution-service/equipmentRoom/addEquipmentRoom", {
            projectId: this.id,
            roomName: name,
            dataType: "1",
          })
          .then((res) => {
            if (res.code) {
              Message.success("创建成功");
              this.getData();
            }
          });
      }
    },
    changeItem(i) {
      if (this.equipmentRoomList.length == 0) return;
      this.timesActiveIndex = i;
    },
    addLi() {
      let arr = this.equipmentRoomList;
      arr.unshift({ roomName: "" });
      this.equipmentRoomList = arr;
      this.equipmentRoomIndex = 0;
      this.$nextTick(() => {
        this.$refs.addDom[0].focus();
      });
    },
    editThis(index) {
      this.equipmentRoomIndex = index;
      console.log(1123);
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.addDom[0].focus();
        });
      });
    },
    updateValue(e, index) {
      this.equipmentRoomList[index].roomName = e.target.value;
    },
    addorEdit(index) {
      this.equipmentRoomIndex = -1;
      const name = this.equipmentRoomList[index].roomName;
      if (!name) {
        Message.warning("请输入内容后再操作");
        return;
      }
      if (this.equipmentRoomList[index].id) {
        const id = this.equipmentRoomList[index].id;
        this.updata(name, id);
      } else {
        this.addEquipmentRoom(name);
      }
    },
    updata(name, id) {
      this.$http
        .post("bma-distribution-service/equipmentRoom/updateEquipmentRoom", {
          projectId: this.id,
          id: id,
          roomName: name,
          dataType: "1",
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success("修改成功");
            this.getData();
          }
        });
    },
    deleteEquipmentRoom(id) {
      this.$http
        .post("bma-distribution-service/equipmentRoom/deleteEquipmentRoom", {
          roomId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success("删除成功");
            this.getData();
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.shebei {
  .time-line {
    position: relative;
    display: flex;
    justify-content: space-between;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      .dot {
        width: 20px;
        height: 20px;
        background: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.03);
        border-radius: 50%;
        padding: 5px;
        box-sizing: border-box;
        z-index: 2;
        .inner {
          width: 10px;
          height: 10px;
          background: #70a6ff;
          border-radius: 50%;
        }
        &.active {
          width: 20px;
          height: 20px;
          background: #3480ff;
          border-radius: 50%;
          box-sizing: border-box;
          padding: 5px;
          .inner {
            width: 10px;
            height: 10px;
            background: #ffffff;
            border-radius: 50%;
          }
        }
      }
      .label {
        margin-top: 10px;
        font-size: 14px;
        color: #667993;
        &.active {
          font-weight: 600;
          color: #0e223d;
        }
      }
    }
    .line {
      position: absolute;
      height: 4px;
      background: #3480ff;
      top: 28px;
      left: 50px;
      right: 50px;
      z-index: 1;
    }
  }
  .main {
    padding-top: 20px;
    background: rgba(16, 57, 126, 0.06);
    width: 100%;
    min-height: 815px;
    position: relative;
    .step1 {
      width: 100%;
      height: 100%;
      padding-top: 128px;
      box-sizing: border-box;
      .box {
        margin: 0 auto;
        width: 386px;
        height: 497px;
        border: 1px solid #dde1e8;
        border-radius: 13px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding: 76px;
        box-sizing: border-box;
        background: #fff;
        .el-button {
          width: 194px;
        }
        &.box2 {
          padding: 15px;
          display: block;
          ul {
            li {
              height: 33px;
              line-height: 33px;
              &:hover {
                background: rgba(16, 57, 126, 0.1);
              }
            }
          }
          .el-button {
            margin-left: 83px;
            margin-top: 40px;
          }
        }
        img {
          width: 234px;
        }
      }
    }
    .step2,
    .box2 {
      .operation-box {
        width: 100%;
        height: 357px;
        border: 1px solid #ebebeb;
        padding: 6px;
        box-sizing: border-box;
        .add {
          width: 100%;
          height: 48px;
          background: #eff1f2;
          text-align: center;
          line-height: 48px;
          font-size: 40px;
          color: #adadad;
          cursor: pointer;
          margin-bottom: 10px;
        }
        ul {
          overflow-y: scroll;
          height: 288px;
          li {
            height: 33px;
            line-height: 33px;
            // text-indent: 15px;
            font-size: 14px;
            color: #152139;
            outline: none;
            position: relative;
            p {
              width: 100%;
              height: 100%;
              text-indent: 15px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              cursor: pointer;
            }
            input {
              width: 100%;
              height: 100%;
              outline: none;
              border: none;
              font-size: 14px;
              text-indent: 15px;
              background: rgba(16, 57, 126, 0.1);
            }
            .icon-box {
              position: absolute;
              right: 10px;
              top: 0;
              width: 120px;
              height: 33px;
              text-align: right;
              display: none;
              .iconfont {
                margin: 0 10px;
                color: rgba(110, 123, 145, 1);
                cursor: pointer;
              }
            }
            &:hover {
              background: rgba(16, 57, 126, 0.1);
              .icon-box {
                display: block;
              }
            }
          }
        }
      }
    }
    .step3 {
    }
  }
}
</style>